/**
 * Preflight object.
 * This object is responsible for managing the preflight checks.
 * @type {Object}
 */
const Preflight = {

	/**
	 * The type of handler for the Preflight object.
	 * @type {string}
	 */
	handler_type: 'files',

	/**
	 * Initialize the Preflight actions.
	 */
	initActions() {
		const excludeBtns = document.querySelectorAll( '.snapshot-pf-exclude-btn' );
		const includeBtns = document.querySelectorAll( '.snapshot-pf-include-btn' );

		const resetAll = document.querySelectorAll( '.snapshot-pf-reset-all' );
		const bulkActions = document.querySelectorAll( '.snapshot-pf-bulk-apply' );
		const paginationLinks = document.querySelectorAll( '.pagenate-link' );
		const paginationStepLinks = document.querySelectorAll( '.pagenate-link-step' );
		const bulkChecks = document.querySelectorAll( '.bulk-checkbox' );

		excludeBtns.forEach( ( btn ) => {
			btn.addEventListener( 'click', this.exclude_item );
		} );
		includeBtns.forEach( ( btn ) => {
			btn.addEventListener( 'click', this.include_item );
		} );

		resetAll.forEach( ( btn ) => {
			btn.addEventListener( 'click', this.include_all );
		} );
		bulkActions.forEach( ( actionItem ) => {
			actionItem.addEventListener( 'click', this.bulkAction );
		} );
		paginationLinks.forEach( ( paginationLink ) => {
			paginationLink.addEventListener( 'click', this.paginatedContent );
		} );
		paginationStepLinks.forEach( ( paginationStepLink ) => {
			paginationStepLink.addEventListener( 'click', this.paginatedStepContent );
		} );
		bulkChecks.forEach( ( checkbox ) => {
			checkbox.addEventListener( 'change', this.bulkCheck );
		} );
	},

	/**
	 * On load handler.
	 * @param {Function} handleManualBackup Callback function to handle manual backup.
	 */
	onLoad( handleManualBackup ) {
		this.createManualBackup = handleManualBackup;

		const pfCancel = document.getElementById( 'snapshot-pf-cancel' );
		if ( ! pfCancel ) {
			return;
		}
		const skipBtns = document.querySelectorAll( '.snapshot-pf-skip-to-bakup' );
		const confirmCancels = document.querySelectorAll( '.snapshot-pf-confirm-cancel' );
		const pfGoBack = document.getElementById( 'snapshot-pf-go-back' );

		if ( skipBtns.length > 0 ) {
			skipBtns.forEach( ( btn ) => {
				btn.addEventListener( 'click', ( e ) => {
					this.skipToBackup( btn );
				} );
			} );
		}

		confirmCancels.forEach( ( btn ) => {
			btn.addEventListener( 'click', this.confirmCancel );
		} );
		pfCancel.addEventListener( 'click', this.pfCancel );
		pfGoBack.addEventListener( 'click', this.pfGoBack );
	},

	/**
	 * Resets the preflight check.
	 */
	preflightReset() {
		const forceStopEl = document.getElementById( 'snapshot-modal-preflight-check' );
		const result = document.getElementById( 'preflight-result' );
		forceStopEl.dataset.force_stop = 'false';
		result.innerHTML = '';
	},

	/**
	 * Finishes the preflight check progress.
	 * @param {Object} results
	 */
	preflightProgressFinish( results ) {
		for ( let eles = results.children, i = 0; i < eles.length; i++ ) {
			SUI.suiAccordion( eles[ i ] );
		}

		SUI.suiCodeSnippet();
		const result_el = document.getElementById( 'preflight-result' );
		SUI.closeModal( 'snapshot-modal-preflight-check', window );

		if ( result_el.childElementCount ) {
			SUI.openModal( 'snapshot-modal-preflight-result', window );
		} else {
			SUI.openModal( 'snapshot-modal-preflight-noissue', window );
		}

		this.initActions();
	},

	/**
	 * Handles the preflight check before creating a manual backup.
	 * @param {string} checking_stage
	 * @param {Object} paths_left
	 * @param {Object} scanned_data
	 */
	async preflightProgress( checking_stage = 'system', paths_left = null, scanned_data = null ) {
		const forceStopEl = document.getElementById( 'snapshot-modal-preflight-check' );
		const pfInprocess = document.querySelector( '.snapshot-pf-inprocess' );
		let onHoldElement = document.querySelector( '.snapshot-pf-step-on-hold' );

		if ( onHoldElement ) {
			while ( onHoldElement ) {
				await new Promise( ( resolve ) => {
					const observer = new MutationObserver( () => {
						if ( ! document.querySelector( '.snapshot-pf-step-on-hold' ) ) {
							observer.disconnect();
							resolve();
						}
					} );

					observer.observe( document.documentElement, { childList: true, subtree: true } );
				} );

				onHoldElement = document.querySelector( '.snapshot-pf-step-on-hold' );
			}
		}

		if ( pfInprocess ) {
			pfInprocess.classList.remove( 'snapshot-pf-inprocess' );
		}

		if ( 'true' === forceStopEl.dataset.force_stop ) {
			return;
		}

		const inProcess = document.getElementById( 'snapshot-pf-' + checking_stage );
		inProcess.classList.add( 'snapshot-pf-inprocess' );
		const pfActive = document.getElementById( 'snapshot-pf-active-process' );
		pfActive.innerText = inProcess.dataset.checking + '...';

		const requestData = {
			action: 'snapshot-preflight_check',
			_wpnonce: document.getElementById( '_wpnonce-snapshot_preflight_check' ).value,
			checking_stage,
			paths_left: JSON.stringify( paths_left ),
			scanned_data: JSON.stringify( scanned_data ),
		};

		if ( 'system' === checking_stage ) {
			setTimeout( function() {
				document.getElementById( 'preflight-done' ).textContent = '5%';
				document.getElementById( 'preflight-progress-bar' ).style.width = '5%';
			}, 20 );
		}

		fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams( requestData ),
		} )
			.then( ( response ) => response.json() )
			.then( ( response ) => {
				const forceStop = document.getElementById( 'snapshot-modal-preflight-check' );

				if ( 'true' === forceStop.dataset.force_stop ) {
					return;
				}

				if ( response.success ) {
					if ( true === response.data.done ) {
						const results = document.getElementById( 'preflight-result' );

						switch ( response.data.checking_stage ) {
							case 'system':
								results.innerHTML += response.data.html;
								checking_stage = 'files';
								document.getElementById( 'preflight-done' ).textContent = '13%';
								document.getElementById( 'preflight-progress-bar' ).style.width = '13%';
								break;
							case 'files':
								results.innerHTML += response.data.html;
								document.getElementById( 'preflight-done' ).textContent = '70%';
								document.getElementById( 'preflight-progress-bar' ).style.width = '70%';
								checking_stage = 'database';
								break;
							case 'database':
								results.innerHTML += response.data.html;
								document.getElementById( 'preflight-done' ).textContent = '100%';
								document.getElementById( 'preflight-progress-bar' ).style.width = '100%';

								const activeModal = document.getElementById( 'snapshot-modal-preflight-check' );
								if ( activeModal && null === document.querySelector( '.snapshot-pf-step-on-hold' ) ) {
									activeModal.querySelector( '.snapshot-pf-confirm-cancel' ).disabled = true;
									activeModal.querySelector( '.snapshot-pf-skip-to-bakup' ).disabled = true;
									setTimeout( () => {
										Preflight.preflightProgressFinish( results );
										activeModal.querySelector( '.snapshot-pf-confirm-cancel' ).disabled = false;
										activeModal.querySelector( '.snapshot-pf-skip-to-bakup' ).disabled = false;
									}, 500 );
								}

								return;
						}
						Preflight.preflightProgress( checking_stage );
					} else if ( 'files' === response.data.checking_stage ) {
						const current = parseInt( document.getElementById( 'preflight-done' ).textContent );
						if ( current < 60 ) {
							const rand = Math.random();
							document.getElementById( 'preflight-done' ).textContent = current + parseInt( 10 * rand ) + '%';
							document.getElementById( 'preflight-progress-bar' ).style.width = current + parseInt( 10 * rand ) + '%';
						}
						Preflight.preflightProgress( response.data.checking_stage, response.data.paths_left, response.data.scanned_data );
					} else {
						Preflight.preflightProgress( response.data.checking_stage );
					}
				}
			} )
			.catch( ( error ) => console.error( 'Error:', error ) );
	},

	/**
	 * Excludes an item from the preflight check.
	 */
	exclude_item() {
		const targetTr = this.closest( 'tr' );
		targetTr.classList.add( 'snapshot-pf-excluded' );
		const excludeCheckbox = targetTr.querySelector( '.snapshot-pf-exclude-checkbox' );
		if ( excludeCheckbox ) {
			excludeCheckbox.checked = true;
		}

		const updateItems = [
			this.dataset.file
		];
		Preflight.save_exclusions( updateItems, this.dataset.check, this.dataset.action );
	},

	/**
	 * Includes an item in the preflight check.
	 */
	include_item() {
		const targetTr = this.closest( 'tr' );
		targetTr.classList.remove( 'snapshot-pf-excluded' );

		const excludeCheckbox = targetTr.querySelector( '.snapshot-pf-exclude-checkbox' );
		if ( excludeCheckbox ) {
			excludeCheckbox.checked = false;
		}

		const updateItems = [
			this.dataset.file
		];
		Preflight.save_exclusions( updateItems, this.dataset.check, this.dataset.action );
	},

	/**
	 * Excludes all items from the preflight check.
	 */
	exclude_all() {
		let type;
		if ( 'undefined' === typeof this.dataset ) {
			type = this.handler_type;
		} else {
			type = this.dataset.check;
		}

		document.querySelectorAll( '.checkbox-' + type ).forEach( ( checkbox ) => {
			checkbox.checked = true;
			checkbox.closest( 'tr' ).classList.add( 'snapshot-pf-excluded' );
		} );
	},

	/**
	 * Includes all items in the preflight check.
	 */
	include_all() {
		let type;
		if ( 'undefined' === typeof this.dataset ) {
			type = this.handler_type;
		} else {
			type = this.dataset.check;
		}

		document.querySelectorAll( '.checkbox-' + type ).forEach( ( checkbox ) => {
			checkbox.checked = false;
			checkbox.closest( 'tr' ).classList.remove( 'snapshot-pf-excluded' );
		} );
		document.getElementById( 'bulk-check-' + type ).checked = false;
	},

	/**
	 * Bulk action for the preflight check.
	 */
	bulkAction() {
		const checkType = this.dataset.check;
		const selectedOpt = this.closest( 'div' ).querySelector( '.snapshot-pf-bulk-actions' ).value;
		const updateItems = [];

		document.querySelectorAll( '.snapshot-pf-' + checkType + '-table ' + '.snapshot-pf-exclude-checkbox' ).forEach( ( checkbox ) => {
			const checked = checkbox.checked;

			if ( true === checked ) {
				const tr = checkbox.closest( 'tr' );
				updateItems.push( tr.dataset.exclusion_path );

				switch ( selectedOpt ) {
					case 'exclude':
						tr.classList.add( 'snapshot-pf-excluded' );
						break;
					case 'include':
						tr.classList.remove( 'snapshot-pf-excluded' );
						break;
					default:
						console.log( 'No action' );
				}
			}
		} );
		Preflight.save_exclusions( updateItems, checkType, selectedOpt );
	},

	/**
	 * Update the exclusions.
	 * @param {Array}  items
	 * @param {string} checkType
	 * @param {string} actionType
	 */
	save_exclusions( items, checkType = 'files', actionType = 'exclude' ) {
		const data = {
			action: 'snapshot-preflight_save_exclusions',
			_wpnonce: document.getElementById( '_wpnonce-snapshot_preflight_check' ).value,
			check: checkType,
			items: JSON.stringify( items ),
			action_type: actionType,
		};

		fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams( data ),
		} )
			.then( ( response ) => response.json() )
			.then( ( response ) => {
			} )
			.catch( ( error ) => console.error( 'Error:', error ) );
	},

	/**
	 * Paginates the content.
	 */
	paginatedContent() {
		const newPage = this.dataset.pagenateLink;
		const active = this.closest( 'ul' ).querySelector( '.sui-active' );
		const oldPage = active.dataset.pagenateLink;
		const checkType = this.dataset.check;

		if ( oldPage !== newPage ) {
			active.classList.remove( 'sui-active' );
			this.classList.add( 'sui-active' );
			document.querySelectorAll( '.snapshot-pf-' + checkType + '-table' + ' tr.paged-' + newPage ).forEach( ( tr ) => {
				tr.classList.remove( 'sui-hidden' );
			} );
			document.querySelectorAll( '.snapshot-pf-' + checkType + '-table' + ' tr.paged-' + oldPage ).forEach( ( tr ) => {
				tr.classList.add( 'sui-hidden' );
			} );
		}
	},

	/**
	 * Paginates the step content.
	 */
	paginatedStepContent() {
		const action = this.dataset.pagenateLink;
		const active = this.closest( 'ul' ).querySelector( '.sui-active' );
		const oldPage = parseInt( active.dataset.pagenateLink );

		if ( ( 'prev' === action && 1 === oldPage ) || ( 'next' === action && oldPage === this.parentElement.childElementCount - 2 ) ) {
			return;
		}

		const newPage = 'next' === action ? oldPage + 1 : oldPage - 1;
		const checkType = this.dataset.check;

		active.classList.remove( 'sui-active' );
		this.closest( 'ul' ).querySelector( '[data-pagenate-link="' + newPage + '"]' ).classList.add( 'sui-active' );
		document.querySelectorAll( '.snapshot-pf-' + checkType + '-table' + ' tr.paged-' + newPage ).forEach( ( tr ) => {
			tr.classList.remove( 'sui-hidden' );
		} );
		document.querySelectorAll( '.snapshot-pf-' + checkType + '-table' + ' tr.paged-' + oldPage ).forEach( ( tr ) => {
			tr.classList.add( 'sui-hidden' );
		} );
	},

	/**
	 * Bulk check.
	 */
	bulkCheck() {
		const checkType = this.dataset.check;
		const checked = this.checked;

		document.querySelectorAll( '.snapshot-pf-' + checkType + '-table ' + '.snapshot-pf-exclude-checkbox' ).forEach( ( checkbox ) => {
			checkbox.checked = checked;
		} );
	},

	/**
	 * Skips to the backup.
	 * @param el
	 */
	skipToBackup( el = null ) {
		if ( el ) {
			const forceStopEl = document.getElementById( 'snapshot-modal-preflight-check' );
			forceStopEl.dataset.force_stop = 'true';
			const activeModal = el.closest( '.sui-modal-content' ).id;
			SUI.closeModal( activeModal, window );
		} else {
			SUI.closeModal( 'snapshot-modal-preflight-noissue', window );
		}

		this.createManualBackup( false, true );
		document.body.style.overflowY = 'auto';
	},

	/**
	 * Confirms the cancel.
	 */
	confirmCancel() {
		const onHold = document.querySelector( '.snapshot-pf-step-on-hold' );
		if ( onHold ) {
			onHold.classList.remove( 'snapshot-pf-step-on-hold' );
		}

		document.querySelector( '.sui-modal.sui-active' ).querySelector( '.sui-modal-content' ).classList.add( 'snapshot-pf-step-on-hold' );
		SUI.openModal( 'snapshot-modal-preflight-cancel', window );
	},

	/**
	 * Cancels the preflight check.
	 */
	pfCancel() {
		SUI.closeModal();
		document.body.style.overflowY = 'auto';
		const form = document.getElementById( 'form-snapshot-create-manual-backup' );
		form.querySelector( '.sui-button' ).classList.remove( 'sui-button-onload-text' );
		form.querySelector( '#manual-backup-comment' ).value = '';
		document.getElementById( 'button-create-backup' ).disabled = false;
		const modal = document.querySelector( '.snapshot-pf-step-on-hold' );
		modal.classList.remove( 'snapshot-pf-step-on-hold' );
		Preflight.preflightCancel();
	},

	/**
	 * Goes back to the preflight check.
	 */
	pfGoBack() {
		SUI.closeModal( 'snapshot-modal-preflight-cancel', window );
		const modal = document.querySelector( '.snapshot-pf-step-on-hold' );
		modal.classList.remove( 'snapshot-pf-step-on-hold' );
		SUI.openModal( modal.id, window );

		modal.classList.remove( 'snapshot-pf-step-on-hold' );

		const progressEl = modal.querySelector( '#preflight-done' );
		if ( progressEl && '100%' === progressEl.innerText ) {
			setTimeout( () => {
				const results = document.getElementById( 'preflight-result' );
				Preflight.preflightProgressFinish( results );
			}, 500 );
		}
	},

	/**
	 * Cancels background preflight check.
	 */
	preflightCancel() {
		const forceStopEl = document.getElementById( 'snapshot-modal-preflight-check' );
		forceStopEl.dataset.force_stop = 'true';
	}
};

export default Preflight;
